import CryptoJS from 'crypto-js';
/**加密方法 */
export const encryption = (word) => {
    if (!word) return '';
    const needToEncrypt = word;
    const secretKey = `)O[NB]6,YF}+efcaj{+oESb9d8>Z'e9M`; // 16位密钥，需要与后端密钥一致（勿改动）
    const key = CryptoJS.enc.Utf8.parse(secretKey);
    const encryptStr = CryptoJS.AES.encrypt(needToEncrypt, key, {
        mode: CryptoJS.mode.ECB, // 加密模式
        padding: CryptoJS.pad.Pkcs7 // 填充方式
    }).toString();
    return encryptStr;
};

/**解密方法 */
export const decryption = (word) => {
    if (!word) return '';
    const secretKey = `)O[NB]6,YF}+efcaj{+oESb9d8>Z'e9M`; // 16位密钥，需要与后端密钥一致（勿改动）
    const key = CryptoJS.enc.Utf8.parse(secretKey);
    const decrypt = CryptoJS.AES.decrypt(word, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
};



// WEBPACK FOOTER //
// ./src/utils/secret.js